import React from 'react';
import clsx from 'clsx';
import CashinClosingOddsIcon from '../../../icons/CashinClosingOddsIcon';

const CashinClosingOdds = ({ odds, mobile }) => {
    if (!odds) {
        return null;
    }
    const currentCashinOdds = Number.parseFloat(odds).toFixed(2);
    return (
        <div className={clsx('flex items-center', { 'pr-20': mobile })}>
            <CashinClosingOddsIcon width={mobile ? 20 : 16} height={mobile ? 20 : 16} />
            <div className={clsx('pl-8 text-bold  closing-color', { 'fs-14 text-extra-bold': mobile })}>
                {currentCashinOdds}
            </div>
        </div>
    );
};

export default CashinClosingOdds;
